import * as z from 'zod';

import { paginatedResponseSchema, percentageInput } from '@/_schemas/generic';
import { statusQuerySchema } from '@/_schemas/status-input';

import { categoryQueryLinkerSchema } from './category-query-linker-schema';

export const categoryQuerySchema = z.object({
  ...categoryQueryLinkerSchema.shape,
  wholesale_discount: percentageInput.querySchema(),
  description: z.string().nullable(),
  sku_prefix: z.string().nullable(),
  status: statusQuerySchema,
  parent_id: z.number().nullable(),
  parent: categoryQueryLinkerSchema.nullish(),
  children: z.array(categoryQueryLinkerSchema).nullish(),
  products_count: z.number(),
});

export type CategoryQuerySchema = z.infer<typeof categoryQuerySchema>;

export const categoryQueryAllSchema = paginatedResponseSchema(categoryQuerySchema);

export type CategoryQueryAllSchema = z.infer<typeof categoryQueryAllSchema>;
